<template>
  <div class="w-full">
    <vs-popup
      v-if="open"
      title="Editar Movimento Financeira"
      :active.sync="modalEditar"
    >
      <div
        class="w-full vs-con-loading__container"
        :id="'loadingEditarDC' + conta.id"
      >
        <div
          class="w-full vs-con-loading__container"
          :id="'loadingSelectsEditarDC' + conta.id"
        >
          <vs-row
            vs-type="flex"
            class="mb-2"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="12"
            >
              <div class="w-full">
                <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                  >Empresa</label
                >
                <br />
                <el-select
                  filterable
                  name="empresa"
                  clearable
                  style="width: 270px"
                  v-model="objConta.id_empresa"
                  :popper-append-to-body="false"
                  class="mx-1 mt-2"
                >
                  <el-option
                    v-for="empresa in empresas"
                    :value="empresa.id"
                    :label="empresa.razao_social"
                    :key="empresa.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="w-full">
                <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                  >Plano Conta</label
                >
                <br />
                <el-select
                  filterable
                  style="width: 270px"
                  clearable
                  remote
                  :remote-method="filtroPlanoConta"
                  :loading="loading"
                  loading-text="Buscando..."
                  name="plano_conta"
                  :popper-append-to-body="false"
                  placeholder="Pesquise"
                  v-model="objConta.id_plano_conta"
                  class="mx-1 mt-2"
                >
                  <el-option
                    v-for="data in plano_conta"
                    :value="data.id"
                    :label="data.nome"
                    :key="data.id"
                  ></el-option>
                </el-select>
              </div>
            </vs-col>
          </vs-row>
          <vs-row
            vs-type="flex"
            class="mb-2"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="12"
            >
              <div class="w-full">
                <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                  >Portador</label
                >
                <br />
                <el-select
                  filterable
                  style="width: 270px"
                  clearable
                  name="portador"
                  :popper-append-to-body="false"
                  v-model="objConta.id_portador"
                  class="mx-1 mt-2"
                >
                  <el-option
                    v-for="data in portadores"
                    :value="data.id"
                    :label="data.nome"
                    :key="data.id"
                  ></el-option>
                </el-select>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <div class="w-full">
              <vs-input
                style="width: 270px"
                color="dark"
                class="mx-2"
                name="data"
                type="date"
                label="Data"
                @change="checkData"
                v-model="objConta.data"
              ></vs-input>
            </div>
            <div class="w-full">
              <vs-input
                color="dark"
                class="mx-1"
                style="width: 270px"
                name="valor"
                v-currency="$currencyFormatterOptions"
                type="text"
                placeholder="R$ 0,00"
                label="Valor"
                v-model="objConta.valor"
              ></vs-input>
            </div>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              class="mx-1 w-fulll"
              style="width: 600px"
              type="text"
              label="Observação"
              v-model="objConta.obs"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-button
              @click="submitForm()"
              class="w-full mt-3"
              color="success"
              type="relief"
              >Editar</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import components from "@/components/default/exports.js";
export default {
  props: {
    conta: {}
  },
  data() {
    return {
      modalEditar: false,
      debito_credito: [
        { id: 1, nome: "Débito" },
        { id: 2, nome: "Crédito" }
      ],
      empresas: {},
      plano_conta: {},
      portadores: {},
      open: false,
      loading: false,
      objConta: {}
    };
  },
  methods: {
    async openModal() {
      this.open = await true;
      this.modalEditar = await true;
      await this.$vs.loading({
        container: "#loadingSelectsEditarDC" + this.conta.id,
        scale: 0.6
      });
      try {
        await this.getEmpresas();
        await this.getPortadores();
        await this.getPlanoContaByQuery(this.conta.id_plano_conta);
        await this.makeObj();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$vs.loading.close(
          "#loadingSelectsEditarDC" + this.conta.id + " > .con-vs-loading"
        );
      }
    },
    async makeObj() {
      try {
        this.objConta = {
          id_empresa: this.conta.id_empresa,
          id_forma_pagamento: this.conta.id_forma_pagamento,
          id_plano_conta: this.conta.id_plano_conta,
          id_portador: this.conta.id_portador,
          valor: this.conta.valor,
          data: this.conta.data,
          obs: this.conta.obs
        };
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async submitForm() {
      try {
        if (
          this.objConta.id_empresa != null &&
          this.objConta.valor != null &&
          this.objConta.id_portador != null &&
          this.objConta.id_plano_conta != null &&
          this.objConta.data != null && this.objConta.data != "" && this.objConta.data != undefined
        ) {
          await this.Editar();
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async Editar() {
      await this.$vs.loading({
        container: "#loadingEditarDC" + this.conta.id,
        scale: 0.6
      });
      try {
        let valor = "" + this.objConta.valor;
        if (valor && valor.search(",") !== -1) {
          valor = valor.replace(/\./g, "");
          valor = valor.replace(/,/g, ".");
        }
        this.objConta.valor = valor;

        const res = await this.$http.put(
          "movimento_financeiro/" + this.conta.id,
          this.objConta
        );
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "financeiro",
          ip: window.localStorage.getItem("ip"),
          texto: "Edição do Movimento Financeiro N°" + res.id
        };
        await this.$logger(logData);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$emit("update");
        this.modalEditar = await false;
        this.open = await false;
        await this.$vs.loading.close(
          "#loadingEditarDC" + this.conta.id + " > .con-vs-loading"
        );
      }
    },
    async getPlanoContaByQuery(query) {
      try {
        this.plano_conta = await this.$http.post(`getPlanoContaByQuery`, {
          query: query
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async filtroPlanoConta(query) {
      if (query.length > 2) {
        this.loading = true;
        try {
          await this.getPlanoContaByQuery(query);
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
        } finally {
          this.loading = false;
        }
      }
    },
    async getPortadores() {
      try {
        this.portadores = await this.$http.get(`portador`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getEmpresas() {
      try {
        this.empresas = await this.$http.get(`empresa`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async checkData() {
      if (this.$atividades.permissoes.includes(25)) {
        return 1;
      }
      var hoje = new Date();
      var data = new Date(this.objConta.data);

      var dia_hoje = hoje.getUTCDate();
      var mes_hoje = hoje.getUTCMonth() + 1;
      var dia_data = data.getUTCDate();
      var mes_data = data.getUTCMonth() + 1;
      var ano_hoje = hoje.getUTCFullYear();
      var ano_data = data.getUTCFullYear();

      console.log("dia_hoje - " + dia_hoje);
      console.log("mes_hoje - " + mes_hoje);
      console.log("dia_data - " + dia_data);
      console.log("mes_data - " + mes_data);
      console.log("ano_hoje - " + ano_hoje);
      console.log("ano_data - " + ano_data);
      if (ano_data < ano_hoje && 0) {
        this.objConta.data = hoje.toISOString().split("T")[0];
        this.$vs.notify({
          title:
            "Não é possível mudar o vencimento do ano anterior. ERR COD 03",
          text: "Ação Negada",
          color: "danger"
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "financeiro",
          ip: window.localStorage.getItem("ip"),
          texto:
            "Tentou alterar para uma data anterior do movimento N°" +
            this.conta.id
        };
        await this.$logger(logData);
        return 1;
      }
      if (dia_hoje > 5) {
        if (mes_data < mes_hoje) {
          this.objConta.data = hoje.toISOString().split("T")[0];
          this.$vs.notify({
            title:
              "Não é possível mudar o vencimento do mês anterior. ERR COD 01",
            text: "Ação Negada",
            color: "danger"
          });
          let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: "atualizar",
            setor: "financeiro",
            ip: window.localStorage.getItem("ip"),
            texto:
              "Tentou alterar para uma data anterior do movimento N°" +
              this.conta.id
          };
          await this.$logger(logData);
          return 1;
        }
      } else {
        if (mes_hoje + 1 < mes_data && !(mes_hoje == 1 && mes_data == 12)) {
          this.objConta.data = hoje.toISOString().split("T")[0];
          this.$vs.notify({
            title:
              "Não é possível mudar o vencimento do mês anterior. ERR COD 02",
            text: "Ação Negada",
            color: "danger"
          });
          let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: "atualizar",
            setor: "financeiro",
            ip: window.localStorage.getItem("ip"),
            texto:
              "Tentou alterar para uma data anterior do movimento N°" +
              this.conta.id
          };
          await this.$logger(logData);
          return 1;
        }
      }
    }
  },
  async mounted() {
    await this.openModal();
  },
  components: {
    ...components
  }
};
</script>
